import { createAction, props } from '@ngrx/store';

import { type FormulaFunctionInfo } from '@blaze-shared/api-contracts-domain';

const TAG = '[Formulas]';

export const fetchFormulaFunctions = createAction(`${TAG} Fetch formula functions`);

export const setFormulaFunctions = createAction(
  `${TAG} Set formula functions`,
  props<{ formulaFunctions: FormulaFunctionInfo[] }>(),
);
